export const PLEO_GUIDE_DOWNLOAD_MOBILE_APP_MODAL_KEY = 'pleoGuideDownloadMobileAppModalKey'
export const PLEO_GUIDE_CARD_READY_POPOVER_KEY = 'pleoGuideVirtualCardPopoverKey'
export const PLEO_GUIDE_AWARENESS_COMPLETED_VALUE = 'completed'
